var _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCertificates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 16,
    fill: "#FFEADB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.492289,
    y: 1.32649,
    width: 26.4119,
    height: 26.6042,
    rx: 3,
    transform: "matrix(0.908751 0.417338 -0.416462 0.909153 32.778 8.91506)",
    fill: "#FFEADB",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 15.3782,
    width: 30.2688,
    height: 38.8738,
    rx: 3,
    fill: "#FFD8DA",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3627 50.7621C28.2177 50.764 27.1027 50.1463 26.1818 49V58.671C26.1818 59.1208 26.7293 59.3419 27.0416 59.0182L28.6441 57.3578C29.0373 56.9504 29.69 56.9504 30.0832 57.3578L31.6857 59.0183C31.998 59.3419 32.5455 59.1208 32.5455 58.671V49C31.6241 50.1472 30.5083 50.7649 29.3627 50.7621Z",
    fill: "#4B4A50",
    stroke: "#4B4A50",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0892 52.1916C32.0595 52.1916 34.4674 49.7837 34.4674 46.8134C34.4674 43.8432 32.0595 41.4353 29.0892 41.4353C26.119 41.4353 23.7111 43.8432 23.7111 46.8134C23.7111 49.7837 26.119 52.1916 29.0892 52.1916Z",
    fill: "#A7163E",
    stroke: "#4B4A50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4537,
    y: 22.9832,
    width: 20.4369,
    height: 2.15125,
    rx: 1,
    fill: "#4B4A50"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4537,
    y: 28.3613,
    width: 20.4369,
    height: 2.15125,
    rx: 1,
    fill: "#4B4A50"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4537,
    y: 33.7393,
    width: 11.8319,
    height: 2.15125,
    rx: 1,
    fill: "#4B4A50"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertificates);
export default __webpack_public_path__ + "static/media/icon-certificates.841cb408f70458c72451ab1276f96e5b.svg";
export { ForwardRef as ReactComponent };